import { Row, Col, FormGroup, Input, Label, Spinner } from "reactstrap"
import { useEffect, useState } from "react"
import GeneratedAd from "../AdWizardComps/GeneratedAd"
import { FileUploader } from "react-drag-drop-files";
import Select from "react-select";
import WizardPlayer from "../AdWizardComps/audioEditorComp/WizardPlayer";
import video from "../../../assets/video/create-advert.mp4"

const WizardAdCreate = (props) => {
    const [isExactText, setIsExactText] = useState(false)
    const [selectedAd, setSelectedAd] = useState(0)
    const [isUploadingNew, setIsUploadingNew] = useState(false)

    const fileTypes = ["MP3", "WAVE", "OGG"]
    const [file, setFile] = useState(null)
    const handleFileChange = (uploadedFile) => {
        const reader = new FileReader();

        reader.onloadend = () => {
            const base64String = reader.result.split(',')[1]
            setFile(base64String);
            props.setBaseObject({ ...props.baseObject, uploadedBase64: base64String })
        };

        if (uploadedFile) {
            reader.readAsDataURL(uploadedFile); // Convert the file to base64
        }
    };

    const [singeSelectDuration, setSingleSelectDuration] = useState({ label: "30 seconds", id: 6 })
    const [durations, setDurations] = useState()
    const handleDurationChange = (value) => {
        setSingleSelectDuration(value)
        props.setBaseObject({ ...props.baseObject, length: value.id })
    }

    const handleSelectAd = (id) => {
        setSelectedAd(id)
        props.setBaseObject({ ...props.baseObject, selectedContent: id })
    }

    const generateDurations = () => {
        const options = [];

        options.push(
            { label: "30 seconds", id: 6 }
        )
        setDurations(options);
    };

    useEffect(() => {
        generateDurations()
    }, [])

    useEffect(() => {
        if (props.baseObject?.content && selectedAd === 0) {
            setSelectedAd(props.baseObject.content[0].id)
        }
    }, [props.baseObject?.content])

    const handleSetGeneration = (isExact) => {
        setIsExactText(isExact)
        props.setBaseObject({ ...props.baseObject, isExactScript: isExact })
    }

    useEffect(() => {
        if (!props.isGenerate) {
            if (file) {
                props.setIsOwnAdvert(true)
            } else {
                props.setIsOwnAdvert(false)
            }
        } else {
            props.setIsOwnAdvert(false)
        }
    }, [props.isGenerate, file])

    useEffect(() => {
        if (props.baseObject.uploadedBase64 != null) {
            setFile(props.baseObject.uploadedBase64)
        }
    }, [props.baseObject])


    useEffect(() => {
        if (isExactText) {
            props.setBaseObject({ ...props.baseObject, script: props.exactScript });
            props.setScript(props.exactScript)
        } else {
            props.setBaseObject({ ...props.baseObject, script: props.nonExactScript });
            props.setScript(props.nonExactScript)
        }
    }, [isExactText]);

    const [playingAudioId, setPlayingAudioId] = useState(null)


    const handleInputChange = (e, wordLimit) => {
        const wordCount = e.target.value.trim().split(/\s+/).length;

        if (wordCount <= wordLimit) {
            // Adjust textarea height dynamically
            e.target.style.height = "auto";
            e.target.style.height = `${e.target.scrollHeight}px`;
            e.target.style.maxHeight = "200px";
            e.target.style.overflowY = "auto";
            e.target.style.setProperty("border", "1px solid transparent", "important");

            const updatedScript = e.target.value;
            props.setScript(updatedScript); // Update local state

            if (isExactText)
                props.setExactScript(updatedScript)
            else
                props.setNonExactScript(updatedScript)

            props.baseObject.script = updatedScript; // Update the prop
        } else {
            e.target.style.setProperty("border", "1px solid #F33B30", "important");
        }
    };

    return (
        <Row className="justify-content-center pb-3" style={{ width: "100%" }}>
            <Col md="12">
                {/* <Row className="justify-content-between mt-4">
                <Col style={{ borderRadius: 7, padding: 7, cursor: "pointer", marginLeft: 5, marginRight: 5, minHeight: 85, display: "flex", justifyContent: "center", flexDirection: "column", backgroundColor: props.isGenerate && "rgba(243,59,48)" }} className={` borderLight`} sm="" onClick={() => props.setIsGenerate(true)}>
                    <p style={{ margin: 0, marginLeft: 5 }}>Create Advert</p>
                    <p style={{ margin: 0, marginLeft: 5 }}>Let our AI create an ad for you or enter your own advert script.</p>
                </Col>
                <Col style={{ borderRadius: 7, padding: 7, cursor: "pointer", marginLeft: 5, marginRight: 5, minHeight: 85, display: "flex", justifyContent: "center", flexDirection: "column", backgroundColor: !props.isGenerate && "rgba(243,59,48)" }} className={` borderLight`} sm="" onClick={() => props.setIsGenerate(false)}>
                    <p style={{ margin: 0, marginLeft: 5 }}>Upload Advert</p>
                    <p style={{ margin: 0, marginLeft: 5 }}>Upload an existing audio advert.</p>
                </Col>
            </Row> */}

                <Row className="justify-content-center mx-auto">
                    <Col md="12">
                        {props.isGenerate ? (
                            <>
                                <Row md="12" pt-0 mt-0>
                                    <Col md="6">
                                        <Row>
                                            <Col>
                                                <h5>Create Advert</h5>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col style={{ paddingRight: 15 }}>
                                                <FormGroup>
                                                    <Label className="labelText">
                                                        Name {props.requiredMissing && props.requiredMissing.includes("name") && <span style={{ color: "red", fontWeight: "bold" }}>required</span>}
                                                    </Label>
                                                    <Input className="inputStyle placeholderWhite reviewInput" placeholder="Enter Campaign Name" value={props.baseObject.name} onChange={(e) => props.setBaseObject({ ...props.baseObject, name: e.target.value })} />
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                        <Row className="mt-2">
                                            <Col className="d-flex" style={{ gap: 15 }}>
                                                <FormGroup check>
                                                    <Label check className="labelText">
                                                        <Input type="checkbox" checked={!isExactText} onClick={() => handleSetGeneration(false)} />
                                                        <span className="form-check-sign" />
                                                        AI script generation
                                                    </Label>
                                                </FormGroup>
                                                <FormGroup check>
                                                    <Label check className="labelText">
                                                        <Input type="checkbox" checked={isExactText} onClick={() => handleSetGeneration(true)} />
                                                        <span className="form-check-sign" />
                                                        Write own script
                                                    </Label>
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col style={{ paddingRight: 15 }}>
                                                {!isExactText ? (
                                                    <>
                                                        <Input
                                                            className="inputStyle placeholderWhite reviewInput"
                                                            placeholder="Enter words or phrases about what you want to advertise, along with your business name and contact details, to enable our AI to create your advert script for you."
                                                            type="textarea"
                                                            value={props.script}
                                                            onChange={(e) => handleInputChange(e, 250)}
                                                            style={{ minHeight: 150, padding: 10 }}
                                                            onBlur={(e) => e.target.style.setProperty("border", "1px solid transparent", "important")}
                                                        />
                                                        <p style={{ margin: 0, textAlign: "right" }}>
                                                            {props.script ? props.script.trim().split(/\s+/).length : 0}/250 words
                                                        </p>
                                                    </>
                                                ) : (
                                                    <>
                                                        <Input
                                                            className="inputStyle placeholderWhite reviewInput"
                                                            placeholder="Enter the exact wording you want used in your advert. 75 words maximum."
                                                            type="textarea"
                                                            value={props.script}
                                                            onChange={(e) => handleInputChange(e, 75)}
                                                            style={{ minHeight: 150, padding: 10 }}
                                                            onBlur={(e) => e.target.style.setProperty("border", "1px solid transparent", "important")}
                                                        />
                                                        <p style={{ margin: 0, textAlign: "right" }}>
                                                            {props.script ? props.script.trim().split(/\s+/).length : 0}/75 words
                                                        </p>
                                                    </>
                                                )}
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col>
                                                {props.isGenerating ? (
                                                    <button type="submit" disabled style={{ minWidth: "100%", backgroundColor: "#F33B30", minHeight: 40, maxHeight: 40, border: "none", boxShadow: "none", borderRadius: 5, color: "#FFF", display: "flex", justifyContent: "center", alignItems: "center", gap: 10 }}>
                                                        <i className="fa fa-list-alt" />
                                                        Create {props.baseObject.id !== 0 && "NEW"} Advert (1 credit)
                                                        <Spinner size="sm" />
                                                    </button>
                                                ) : (
                                                    <button onClick={() => props.handleAddAdvert()} type="submit" style={{ minWidth: "100%", backgroundColor: "#F33B30", minHeight: 40, maxHeight: 40, border: "none", boxShadow: "none", borderRadius: 5, color: "#FFF", display: "flex", justifyContent: "center", alignItems: "center", gap: 10 }}>
                                                        <i className="fa fa-list-alt" />
                                                        Create {props.baseObject.id !== 0 && "NEW"} Advert (1 credit)
                                                    </button>
                                                )}
                                                {props.isGeneratingError && (
                                                    <div>
                                                        <span style={{ color: "#F33B30", fontWeight: "bold" }}>Something went wrong, please try again later</span>
                                                    </div>
                                                )}
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md="6" pt-0 mt-0>
                                        <h3>Tutorial - How to create an advert</h3>
                                        <video src={video} width="100%" controls></video>
                                    </Col>
                                </Row>

                                <Row className="mt-2">
                                    {props.baseObject?.content && props.baseObject?.content.length > 0 && (
                                        <Col>
                                            <Row>
                                                <Col>
                                                    <p>Your advert has been created!</p>
                                                    <p style={{ margin: 0 }}>
                                                        Choose from 1 of the 3 versions below or change the voice and background music and regenerate any of them. Want to change the words?
                                                    </p>
                                                    <p>
                                                        Simply change the details in the text box above and click the 'Create Advert' button again.
                                                    </p>
                                                </Col>
                                            </Row>
                                            {!props.baseObject?.content ? (
                                                <Row>
                                                    <Col style={{ width: "100%", backgroundColor: "#F33B30", border: "none", boxShadow: "none", borderRadius: 5, color: "#FFF", padding: 10, margin: "auto", display: "flex", flexDirection: "column", gap: 10 }}>
                                                        <Row style={{ display: "flex", gap: 15, alignItems: "center" }}>
                                                            <Col><i className="fa fa-info-circle" /></Col>
                                                            <Col>Your Generated Ads</Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>Your Klaxon.AI ads will appear here once you have generated them.</Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            ) : (
                                                props.baseObject?.content.map((ad, index) => (
                                                    <Row key={index} className="mb-4">
                                                        <Col>
                                                            <Label className="labelText">Option {index + 1}</Label>
                                                            <Col sm="">
                                                                <GeneratedAd
                                                                    advert={ad}
                                                                    setModalPage={props.setModalPage}
                                                                    regenerateContent={props.regenerateContent}
                                                                    handlePreviewVoice={props.handlePreviewVoice}
                                                                    voices={props.voices}
                                                                    music={props.music}
                                                                    singleLoadId={props.singleLoadId}
                                                                    loadingAudio={props.loadingAudio}
                                                                    playingAudioId={playingAudioId}
                                                                    setPlayingAudioId={setPlayingAudioId}
                                                                    audioId={index}
                                                                    isFirst={true}
                                                                />
                                                            </Col>
                                                            <Col className="d-flex justify-content-center">
                                                                <button type="submit" style={{ position: "relative", minWidth: "50%", backgroundColor: "#F33B30", minHeight: 40, maxHeight: 40, border: "none", boxShadow: "none", borderRadius: 5, color: "#FFF", display: "flex", justifyContent: "center", alignItems: "center", gap: 10, cursor: "pointer" }} onClick={() => handleSelectAd(ad.id)}>
                                                                    {selectedAd === ad.id ? "Advert selected" : "Select this advert"}
                                                                    {selectedAd === ad.id && (
                                                                        <div style={{ position: "absolute", right: 20 }}>
                                                                            <i className="fa fa-check" />
                                                                        </div>
                                                                    )}
                                                                </button>
                                                            </Col>
                                                        </Col>
                                                    </Row>
                                                ))
                                            )}
                                        </Col>
                                    )}
                                </Row>
                            </>
                        ) : (
                            <>
                                {!file ? (
                                    <Row>
                                        <Col>
                                            <h5>Upload Advert</h5>
                                            <Row>
                                                <Col>
                                                    <FileUploader handleChange={handleFileChange} name="file" types={fileTypes} classes="wideUpload klaxonColorUpload" label="Click to upload or drag and drop" />
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                ) : (
                                    <Row className="mt-4 mb-4 pb-4">
                                        <Col>
                                            <h5>Preview Advert</h5>
                                            <Row className="pb-4">
                                                <Col>
                                                    <WizardPlayer fileURL={file} />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    {!isUploadingNew ? (
                                                        <button onClick={() => setIsUploadingNew(true)} type="submit" style={{ backgroundColor: "#F33B30", minHeight: 40, maxHeight: 40, border: "none", boxShadow: "none", borderRadius: 5, color: "#FFF", display: "flex", justifyContent: "center", alignItems: "center", gap: 10 }}>
                                                            Upload a different advert
                                                        </button>
                                                    ) : (
                                                        <FileUploader handleChange={handleFileChange} name="file" types={fileTypes} classes="wideUpload klaxonColorUpload" label="Upload a different advert" />
                                                    )}
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                )}
                            </>
                        )}
                    </Col>
                </Row>
            </Col>
        </Row>
    )

}

export default WizardAdCreate 